export const TITLE_KEYWORDS = [
  // English
 'PROFESSIONAL SUMMARY',
    'SUMMARY',
    'PROFILE',
    'PROFESSIONAL PROFILE',
    'CAREER OBJECTIVE',
    'OBJECTIVE',
    'CORE COMPETENCIES',
    'CORE COMPETENCIES & SKILLS',
    'Core Competencies & Skills',
    'CORE SKILLS',
    'SKILLS',
    'KEY SKILLS',
    'TECHNICAL SKILLS',
    'SOFT SKILLS',
    'PROFESSIONAL EXPERIENCE',
    'WORK EXPERIENCE',
    'EXPERIENCE',
    'EMPLOYMENT HISTORY',
    'PROJECTS',
    'ACADEMIC PROJECTS',
    'EDUCATION',
    'ACADEMIC BACKGROUND',
    'CERTIFICATIONS',
    'TRAINING',
    'ACHIEVEMENTS',
    'ACCOMPLISHMENTS',
    'AWARDS',
    'PUBLICATIONS',
    'RESEARCH',
    'INTERNSHIPS',
    'VOLUNTEER EXPERIENCE',
    'EXTRACURRICULAR ACTIVITIES',
    'ADDITIONAL INFORMATION',
    'PERSONAL INFORMATION',
    'INTERESTS',
    'EDUCATION QUALIFICATIONS',
    'ADDITIONAL INFORMATION (OPTIONAL)',
    'HOBBIES',
    'LANGUAGES',
    'REFERENCES',

    /* ===================== FRENCH ===================== */
    'RÉSUMÉ',
    'PROFIL',
    'PROFIL PROFESSIONNEL',
    'RÉSUMÉ PROFESSIONNEL',
    'OBJECTIF',
    'OBJECTIF PROFESSIONNEL',
    'OBJECTIF DE CARRIÈRE',
    'COMPÉTENCES',
    'COMPÉTENCES CLÉS',
    'COMPÉTENCES PRINCIPALES',
    'COMPÉTENCES TECHNIQUES',
    'EXPÉRIENCE PROFESSIONNELLE',
    'EXPÉRIENCE',
    'PARCOURS PROFESSIONNEL',
    'INFORMATIONS COMPLÉMENTAIRES',
    'PROJETS',
    'FORMATION',
    'FORMATION ACADÉMIQUE',
    'DIPLÔMES',
    'CERTIFICATIONS',
    'FORMATIONS',
    'RÉALISATIONS',
    'DISTINCTIONS',
    'PUBLICATIONS',
    'RECHERCHE',
    'STAGES',
    'EXPÉRIENCE BÉNÉVOLE',
    'ACTIVITÉS EXTRA-PROFESSIONNELLES',
    'INFORMATIONS COMPLÉMENTAIRES',
    'CENTRES D\'INTÉRÊT',
    'LANGUES',
    'RÉFÉRENCES',

    /* ===================== SPANISH ===================== */
    'RESUMEN',
    'RESUMEN PROFESIONAL',
    'PERFIL',
    'PERFIL PROFESIONAL',
    'OBJETIVO',
    'OBJETIVO PROFESIONAL',
    'COMPETENCIAS CLAVE',
    'Competencias Clave y Habilidades',
    'OBJETIVO LABORAL',
    'HABILIDADES',
    'HABILIDADES CLAVE',
    'HABILIDADES TÉCNICAS',
    'COMPETENCIAS',
    'EXPERIENCIA PROFESIONAL',
    'EXPERIENCIA LABORAL',
    'HISTORIAL LABORAL',
    'PROYECTOS',
    'EDUCACIÓN',
    'EXPERIENCIA',
    'FORMACIÓN ACADÉMICA',
    'TÍTULOS',
    'CERTIFICACIONES',
    'CAPACITACIÓN',
    'LOGROS',
    'RECONOCIMIENTOS',
    'PUBLICACIONES',
    'INVESTIGACIÓN',
    'PRÁCTICAS',
    'EXPERIENCIA VOLUNTARIA',
    'ACTIVIDADES EXTRACURRICULARES',
    'INFORMACIÓN ADICIONAL',
    'INTERESES',
    'IDIOMAS',
    'REFERENCIAS',

    /* ===================== GERMAN ===================== */
    'PROFIL',
    'BERUFLICHES PROFIL',
    'ZUSAMMENFASSUNG',
    'PROFESSIONELLE ZUSAMMENFASSUNG',
    'BERUFSZIEL',
    'KARRIEREZIEL',
    'BERUFSERFAHRUNG',
    'FÄHIGKEITEN',
    'KENNTNISSE',
    'KERNKOMPETENZEN',
    'SCHLÜSSELKOMPETENZEN',
    'TECHNISCHE KENNTNISSE',
    'BERUFSERFAHRUNG',
    'PROFESSIONELLE ERFAHRUNG',
    'ARBEITSERFAHRUNG',
  'PROJEKTE',
    'AUSBILDUNG',
    'BILDUNGSWEG',
    'AKADEMISCHE AUSBILDUNG',
    'ABSCHLÜSSE',
    'ZERTIFIKATE',
    'WEITERBILDUNG',
    'ERFOLGE',
    'AUSZEICHNUNGEN',
    'VERÖFFENTLICHUNGEN',
    'FORSCHUNG',
    'PRAKTIKA',
    'EHRENAMTLICHE ERFAHRUNG',
    'ZUSÄTZLICHE INFORMATIONEN',
    'INTERESSEN',
    'SPRACHEN',
    'REFERENZEN'
];

export const NORMALIZED_TITLE_KEYWORDS = new Set(
  TITLE_KEYWORDS.map(k => k.trim().toLowerCase())
);
